import { IMenuModel } from './menu.models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs'
import { tap } from 'rxjs/operators';

@Injectable()
export class MenuService {
    public loaded = new Subject<IMenuModel>()
    private apiKey
    private path = '/_mvc/booking/menu'
    constructor(private http: HttpClient) { }

    public setApiKey(key) {
        this.apiKey = { 'X-Api-Key': key }
    }

    public useBlocking(waitHandle) {
        this.path = `/sbwapi/booking/blockingmenu?wait=${waitHandle}`
    }

    public loadMenu(): Observable<IMenuModel> {
        let headers = { 'Accept': 'application/json', ...this.apiKey }
        return this.http.get<IMenuModel>(this.path, { headers }).pipe(tap(x => this.loaded.next(x)))
    }
}
